import { render, staticRenderFns } from "./UnauthorizedFeaturePdv.vue?vue&type=template&id=971eb198&"
import script from "./UnauthorizedFeaturePdv.vue?vue&type=script&lang=js&"
export * from "./UnauthorizedFeaturePdv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports